export default {
    namespaced: true,
    state: {
        snackbar: {
            visible: false,
            color: null,
            message: null
        },
    },
    mutations: {
        SHOW_SNACKBAR(state, snackbar) {
            state.snackbar = snackbar;
        }
    },
    actions: {
        SHOW_SNACKBAR({ commit }, snackbar) {
            commit('SHOW_SNACKBAR', snackbar)
        }
    },
}